export default "__VITE_PUBLIC_ASSET__c3837808__"